import React from 'react';

// Компонент навигации для нижнего меню в стиле claymorphic
const Navigation = ({ activeSection, onSectionChange, sections }) => {
  // Иконки для нижнего меню
  const icons = {
    home: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    ),
    search: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
    ),
    add: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    ),
    activity: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
    ),
    profile: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
  };

  return (
    <div className="bottom-nav">
      <div 
        className={`nav-item ${activeSection === 'home' ? 'active' : ''}`} 
        onClick={() => onSectionChange('home')}
      >
        {icons.home}
        <span>Главная</span>
      </div>
      
      <div 
        className={`nav-item ${activeSection === 'chain' ? 'active' : ''}`} 
        onClick={() => onSectionChange('chain')}
      >
        {icons.search}
        <span>Поиск</span>
      </div>
      
      <div 
        className="nav-item add-button"
        onClick={() => onSectionChange('invites')}
      >
        {icons.add}
      </div>
      
      <div 
        className={`nav-item ${activeSection === 'notifications' ? 'active' : ''}`} 
        onClick={() => onSectionChange('notifications')}
      >
        {icons.activity}
        <span>Сообщения</span>
      </div>
      
      <div 
        className={`nav-item ${activeSection === 'profile' ? 'active' : ''}`} 
        onClick={() => onSectionChange('profile')}
      >
        {icons.profile}
        <span>Профиль</span>
      </div>
    </div>
  );
};

export default Navigation; 